import {
    GET_ALL_SCHEDULED_PICKUP,
    GET_ALL_SCHEDULED_PICKUP_USER_DATA,
    GET_SCHEDULED_PICKUP_DASHBOARD,
    RESPONSE_STATUS,
    GET_SCHEDULE_DATA,
    CLEAR_RESPONSE,
    GET_TODAY_COMPLETED,
    GET_TODAY_SERVING,
    GET_TODAY_WAITLIST,
    GET_TODAY_BOOKING,
} from './scheduledPickupTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_SCHEDULED_PICKUP:
            return {
                ...state,
                all_scheduled_pickup: action.payload,
            }
        case GET_TODAY_COMPLETED:
            return {
                ...state,
                completed_scheduled_pickup: action.payload,
            }
        case GET_SCHEDULED_PICKUP_DASHBOARD:
            return {
                ...state,
                scheduled_pickup_dashboard: action.payload,
            }
        case GET_TODAY_SERVING:
            return {
                ...state,
                serving_scheduled_pickup: action.payload,
            }
        case GET_SCHEDULE_DATA:
            return {
                ...state,
                schedule_data: action.payload,
            }
        case GET_TODAY_WAITLIST:
            return {
                ...state,
                waiting_scheduled_pickup: action.payload,
            }
        case GET_TODAY_BOOKING:
            return {
                ...state,
                booking_scheduled_pickup: action.payload,
            }
        case GET_ALL_SCHEDULED_PICKUP_USER_DATA:
            return {
                ...state,
                all_scheduled_pickup_user: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }

        default:
            return state
    }
}
